import React, { createContext, useState } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [organizationName, setorganizationName] = useState('')

    return (
        <UserContext.Provider value={{ user, setUser,organizationName, setorganizationName }}>
            {children}
        </UserContext.Provider>
    );
};